import { mapGetters } from 'vuex';
import { getMenuScheme, visibilityDependOnAcl, visibilityDependOnAccountTypes } from '@/components/Panel/MenuCommon';

export default {
  name: 'BottomMenu',
  
  components: {},

  props: ['subscriber'],

  computed: {
    ...mapGetters(['acl']),
    availableMenu() {
      return getMenuScheme().map(menu => ({
        ...menu,
        isVisible:
          visibilityDependOnAcl(this, menu)
          && visibilityDependOnAccountTypes(this, menu)
          && menu.isVisibleOnBottom,
      }));
    },
  },

  methods: {
    changeUrl(pathObject) {
      const { name, params } = pathObject;
      this.$router.push({ name, params });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Panel/BottomMenu/component.js